var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.598206,
    width: 56.4019,
    height: 56.4019,
    rx: 28.2009,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1556 38.1997C18.9523 38.1997 17.2748 37.3985 16.1231 35.7961C14.9714 34.1937 14.3955 31.8903 14.3955 28.8858C14.3955 25.8813 14.9714 23.5779 16.1231 21.9755C17.2748 20.3731 18.9523 19.5719 21.1556 19.5719C23.3589 19.5719 25.0364 20.3731 26.1881 21.9755C27.3398 23.5779 27.9157 25.8813 27.9157 28.8858C27.9157 31.9153 27.3398 34.2188 26.1881 35.8212C25.0364 37.4236 23.3589 38.1997 21.1556 38.1997ZM21.1556 35.8713C23.8096 35.8713 25.1365 33.5428 25.1365 28.8858C25.1365 24.2289 23.8096 21.9004 21.1556 21.9004C18.5016 21.9004 17.1997 24.2289 17.1997 28.8858C17.1997 33.5428 18.5016 35.8713 21.1556 35.8713ZM33.0339 35.4707H42.3478V37.7991H30.0294L30.1045 36.6725C30.1546 35.4707 30.43 34.2939 30.9307 33.1672C31.4816 31.8903 32.6082 30.8137 34.3358 29.9124L36.3639 28.7857C37.4154 28.2348 38.1916 27.659 38.6673 27.0581C39.118 26.4572 39.3683 25.7311 39.3683 24.8798C39.3683 23.9785 39.0679 23.2524 38.492 22.7016C37.9162 22.1758 37.115 21.9004 36.1135 21.9004C33.81 21.9004 32.6834 23.1022 32.6834 25.4807H30.0544C30.0294 23.628 30.5552 22.1758 31.6318 21.1242C32.6834 20.0977 34.2106 19.5719 36.1886 19.5719C37.9913 19.5719 39.4184 20.0727 40.495 21.0241C41.5716 22.0256 42.1225 23.2774 42.1225 24.7797C42.1225 26.0316 41.7719 27.1332 41.0709 28.0846C40.3698 29.036 39.2682 29.9124 37.7659 30.7136L35.9883 31.715C34.9618 32.2909 34.2357 32.8417 33.785 33.3926C33.3343 33.9434 33.084 34.6444 33.0339 35.4707Z",
    fill: "#6C6C6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02);
export default __webpack_public_path__ + "static/media/02.70ee7d676fdcd0c72247ace3661d545e.svg";
export { ForwardRef as ReactComponent };